import { Box } from '@spark-web/box';
import { ThemeProvider } from '@spark-web/theme';

import { usePartnerConfig } from '~/context/PartnerConfigContext';
import { useStepContext } from '~/provider/StepProvider';
import { toSparkTheme } from '~/utils/theme';

export const ProgressBar = () => {
  const { currentStepIndex, totalSteps } = useStepContext();
  const config = usePartnerConfig();

  const theme = toSparkTheme(config?.configuration?.sparkThemeName);

  return (
    <ThemeProvider theme={theme}>
      <Box width="full">
        <Box
          background="infoLow"
          borderRadius="large"
          css={{
            position: 'relative',
            overflow: 'hidden',
            height: '8px',
          }}
        >
          <Box
            background={PARTNER_BACKGROUND_BAR_COLOR[theme] || 'primary'}
            height="full"
            css={{
              width: `${((currentStepIndex + 1) / totalSteps) * 100}%`,
              transition: 'width 0.3s ease',
            }}
          />
        </Box>
      </Box>
    </ThemeProvider>
  );
};

const PARTNER_BACKGROUND_BAR_COLOR: Record<string, string> = {
  brighte: 'primary',
  pantheon: 'fieldAccent',
  bravo: 'info',
};
